export const CLOTHING_PROCUREMENT_API_PATHS = {
  forecast: '/admin/clothing/procurement-forecast'
};

export const CLOTHING_REQUEST_REPEAT_PATH = '/repeat';
export const CLOTHING_PATH_SEPARATOR = '/';

export const CLOTHING_PROCUREMENT_QUERY_PARAMS = {
  expectedArrivalDate: 'expectedArrivalDate',
  leadTimeDays: 'leadTimeDays',
  safetyBufferPercent: 'safetyBufferPercent',
  groupIds: 'groupIds',
  catalogItemId: 'catalogItemId',
  shortageOnly: 'shortageOnly'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/clothing-service.constants.ts